import React from 'react';
import { Route } from 'react-router-dom';
import {} from './AllowAny.types';
const AllowAny = ({ component, location, ...rest }) => (React.createElement(Route, { ...rest, render: (props) => React.createElement(component, { ...rest, ...props, location }) }));
AllowAny.defaultProps = {
    location: undefined,
};
export default AllowAny;
